import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';
import { AppState } from '../../store/rootReducer';
import './UnauthorizedAccess.scss';

export default function UnauthorizedAccess() {
  const { ipBlockedMessage } = useSelector((state: AppState) => state.applications);

  const handleRetry = () => {
    window.location.href = '/';
  };

  return (
    <div className="unauthorized-access-container">
      <div className="unauthorized-access-card">
        <div className="error-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="36" stroke="#d32f2f" strokeWidth="8" />
            <text x="40" y="48" textAnchor="middle" fontSize="60" fontWeight="bold" fill="#d32f2f">
              !
            </text>
          </svg>
        </div>

        <h1>Access Restricted</h1>

        <p className="error-message">
          {ipBlockedMessage || 'Access from your current IP address is not permitted for this client.'}
        </p>

        <div className="details">
          <p>
            This restriction is in place for security purposes. If you believe this is an error, please contact
            your system administrator.
          </p>
        </div>

        <div className="actions">
          <Button
            themeColor="primary"
            size="large"
            onClick={handleRetry}
            className="retry-button"
          >
            Try Again
          </Button>
        </div>

        <div className="footer-note">
          <small>If the problem persists, please clear your browser cache and refresh the page.</small>
        </div>
      </div>
    </div>
  );
}
